import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class LocalesLoader implements TranslateLoader {
  private settingsService = inject(SettingsService);

  public getTranslation(_: string): Observable<TranslationObject> {
    return of(this.settingsService.settings.locales);
  }
}
